<template>
  <div class="btn-group">
    <button type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
      Aktion
    </button>
    <div class="dropdown-menu">
      <div v-if="coachBill.status === 'pending' ">
        <button
            class="dropdown-item"
            @click.prevent="approveBill(coachBill.id)">
          Genehmigt
        </button>

        <button
            class="dropdown-item"
            @click.prevent="rejectBill(coachBill.id)">
          Abgelehnt
        </button>
      </div>


      <button
          v-if="coachBill.coachingType === 'private_coaching'"
          class="dropdown-item"
          @click.prevent="printPrivateCoaching">
        Drucken
      </button>
      <button
          v-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType === 'pauschalbetrag'"
          class="dropdown-item"
          @click.prevent="printGroupCoachingPauschal">
        Drucken
      </button>
      <button
          v-else-if="
          coachBill.coachingType === 'group_coaching' &&
          coachBill.billingType !== 'pauschalbetrag'"
          class="dropdown-item"
          @click.prevent="printGroupCoachingHourly">
        Drucken
      </button>
      <button
          v-if="coachBill.coachingType === 'assisted_living_coaching'"
          class="dropdown-item"
          @click.prevent="printAssistedLivingCoaching">
        Drucken
      </button>
      <button
          v-if="coachBill.coachingType === 'case_management_coaching'"
          class="dropdown-item"
          @click.prevent="printCaseManagementCoaching">
        Drucken
      </button>
    </div>
  </div>
</template>

<script setup>
import { CloseToast } from '@/components/VueToast';
import { downloadFile } from '@/shared/functions';
import { defineEmits, defineProps } from 'vue';

const emit  = defineEmits([ 'rejectBill', 'showReasonForRejection', 'createBill' ]);
const props = defineProps({
  coachBill: {
    type: Object,
    required: true,
  },
});

// Approve and reject
const approveBill = (id) => {
  CloseToast();
  emit('approveBill', id);
};

const rejectBill = (id) => {
  CloseToast();
  emit('rejectBill', id);
};


// Print
const printPrivateCoaching = () => {
  downloadFile(
      `/coach-billing/private-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingHourly = () => {
  downloadFile(
      `/coach-billing/group-coaching/hourly-wages-bill-print/${props.coachBill.id}`,
      undefined,
  );
};

const printGroupCoachingPauschal = () => {
  downloadFile(
      `/coach-billing/group-coaching/pauschal-print/${props.coachBill.id}`,
      undefined,
  );
};

const printAssistedLivingCoaching = () => {
  downloadFile(
      `/coach-billing/assisted-living-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};

const printCaseManagementCoaching = () => {
  downloadFile(
      `/coach-billing/case-management-coaching/print-bill/${props.coachBill.id}`,
      undefined,
  );
};
</script>